import type { FC } from 'react';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RiFlag2Line as FlagIcon } from 'react-icons/ri';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, Stack, Typography } from '@mui/material';

import useFollowUpDetail from 'src/components/myFollowUp/MyFollowUpPage/FollowUpOverview/FollowUpDetailModal/FollowUpDetailContext';

import HeadcountPill from '../HeadcountPill';

import { styles } from './index.styles';
import { styles as followUpDetailModalStyles } from 'src/components/myFollowUp/MyFollowUpPage/FollowUpOverview/FollowUpDetailModal/index.styles';

const OrgUnitOverview: FC = () => {
  const { t } = useTranslation('myFollowUp');
  const { actionItem } = useFollowUpDetail();
  const [showPath, setShowPath] = useState(false);
  if (!actionItem) return null;

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Stack
        direction="row"
        sx={{ flexWrap: 'wrap', gap: 1, alignItems: 'baseline' }}
      >
        <Typography component="span">{t('orgUnit.orgUnit')}:</Typography>
        <HeadcountPill />
      </Stack>
      <Stack direction="row" sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
        {actionItem.orgUnits.map((orgUnitPath, i) => (
          <Box
            key={`relatedOrgUnit${i}`}
            sx={{ mr: 4, mb: 2, overflow: 'hidden' }}
          >
            <Typography sx={{ fontSize: 12 }}>
              {t('orgUnit.selected', { number: i + 1 })}
            </Typography>
            <Stack
              direction="row"
              sx={{ flexWrap: 'wrap', overflow: 'hidden' }}
            >
              {showPath ? (
                orgUnitPath
                  .slice(orgUnitPath.length === 1 ? 0 : 1)
                  .map(({ name, priority }, j) => (
                    <Fragment key={`orgUnit${j}`}>
                      {j > 0 && <ArrowForwardRoundedIcon sx={styles.arrow} />}
                      <Box
                        sx={[
                          followUpDetailModalStyles.pill,
                          ...(orgUnitPath[orgUnitPath.length - 1].priority
                            ? [followUpDetailModalStyles.priorityPill]
                            : []),
                        ]}
                      >
                        {priority && <FlagIcon size="16px" />}
                        {name}
                      </Box>
                    </Fragment>
                  ))
              ) : (
                <Box
                  sx={[
                    followUpDetailModalStyles.pill,
                    ...(orgUnitPath[orgUnitPath.length - 1].priority
                      ? [followUpDetailModalStyles.priorityPill]
                      : []),
                  ]}
                >
                  {orgUnitPath[orgUnitPath.length - 1].priority && (
                    <FlagIcon size="16px" />
                  )}
                  {orgUnitPath[orgUnitPath.length - 1].name}
                </Box>
              )}
            </Stack>
          </Box>
        ))}
      </Stack>

      <Button
        endIcon={
          <ExpandMoreIcon
            color="primary"
            sx={followUpDetailModalStyles.expand(showPath)}
          />
        }
        variant="text"
        onClick={() => setShowPath((prev) => !prev)}
        sx={followUpDetailModalStyles.button}
      >
        {showPath ? t('orgUnit.hidePath') : t('orgUnit.fullPath')}
      </Button>
    </Box>
  );
};

export default OrgUnitOverview;
